module.exports = __webpack_public_path__ + "static/media/1007523.4b12fbfb.jpg";